import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const IndexPage = lazy(() => import('./pages'));

export default {
    path: 'proizvodi',
    title: 'Proizvodi',
    Component: IndexPage,
} satisfies RouteObject;
